import { DoctorWithSlots } from "types";
import { transformDoctor } from "./transformDoctor";
import transformSlots from "./transformSlots";

const transformDoctorWithSlots = (data: any): DoctorWithSlots => {
  const doctor = transformDoctor(data);
  const slots = transformSlots(data);

  return { ...doctor, slots };
};

export { transformDoctorWithSlots };
